module.exports = {
    // basic
    'delete-all-access': 'delete all access',
    'well-flags': 'well flags',
    'well-name': 'well name',
    'my-well-groups': 'my well groups',
    'well-group': 'well group',
    'a-well-group': 'a well group',
    'a-user': 'a user',
    'well-group-name': 'well group name',
    'hole-direction': 'hole direction',
    'hole-directions': 'hole directions',
    'pad-name': 'pad name',
    'pad-number': 'pad number',
    'pending-approvals': 'pending approvals',
    'maintenance-invoice-settings': 'maintenance invoice settings',
    'historical': 'historical',
    'source-well': 'source well',
    'new-well-data': 'new well data',
    'disabled': 'disabled',
    'well-aliases': 'well aliases',
    // raw
    'search-by-api': 'Search by API',
    'spud-date-required': 'Please enter a valid spud date.',
    'api-invalid': `API must be 10 or 14 digits, no dashes.`,
    'rig-no-company-message': 'Please select a company.',
    //well header template
    'copy-from-default-title': 'Copy From Default',
    'copy-from-default-template': 'The current template will be replaced with the Default template data. \r\nContinue?',
    'edit-default-template': `This will result in the well header display returning to the default template for this company's wells. Continue ?`,
    'delete-template': `The template will be removed. Continue ?`,
    'company-header-title': (companyName) => `Edit "${companyName[0]}" Well Header Template`,
    'defaut-header-title': `Edit Default Well Header Template`,
    'no-template-field-error': `Please select at least one field`,
    'duplicate-template-field-error': `You have duplicate fields, please remove`,



    // template
    'wells-reset-filters-help': (words) => `Clicking <b>${words[0]}</b> will reset all filters, except for selected columns.`,
    'wellbore-group-delete-confirm': (words) => `Are you sure you want to delete "${words[0]}" from your well groups?`,
    'well-has-no-users-of-role-type': (words) => `This well has no ${words[0]}.`,
    'batch-copy-well-header-help': `
        With the following exceptions, all data (<b>including access</b>) for new wells will be copied from <b>Source Well</b>:
        <ul>
            <li>Well Name</li>
            <li>Any field specified in the uploaded CSV file.</li>
            <ul>
                <li>Any data contained in the CSV file will replace the data copied from <b>Source Well</b>.</li>
            </ul>
        </ul>
    `,
    'batch-copy-well-footer-help': `
        <ul>
            <li>Only one file is allowed.</li>
            <li>File must have .csv extension.</li>
            <li>Required fields are as follows:
                <ul>
                    <li>Well</li>
                </ul>
            </li>
            <li>Any value that can't be interpreted (ie. badly formatted date) or can't be found (ie. a specific asset name or well tag name) will be ignored.</li>
            <li>All wellbore tags from the source well will be added to the new wells, and set to empty values by default.  You can specify values for tags by adding the tag name, and values for each well, in any column after the "Template" column.  That tag on the new well will be set to the value you specify.</li>
        </ul>
    `,

};
